// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AtXH","label":"styles_label__2fIAu"};